/*global VeloxViewController, VeloxWebView, moment, veloxScriptLoader*/

var pkg = require("../../../package.json") ;

var dashboardController = new VeloxViewController({
    directory : "views/dashboard",
    name: "dashboard",
    route: "dashboard" 
}) ;

module.exports = dashboardController ;

dashboardController.onChosenYear = function(){
    this.view.longTask(function(done){
        this.view.updateData() ;
        this.computeStats(this.data, function(err){
            if(err){ return done(err) ;}
            this.view.render() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

dashboardController.prepareDataOnEnter = function(data, callback){
    this.api.api.multiread({
        diag: { searchFirst : {}, orderBy: "d_date"}
    }, function(err, reads){
        if(err){ return callback(err) ;}
        var years = [];
        var dt = moment().startOf("year") ;
        if(reads.diag){
            dt = moment(reads.diag.d_date).startOf("year") ;
        }
        var end = moment().startOf("year") ;
        while(dt.isBefore(end) || dt.isSame(end)){
            years.push({name: dt.year(), year: dt.year()}) ;
            dt = dt.add(1, "year") ;
        }
        var data = {
            years: years.reverse(),
            chosenYear: moment().year()
        } ;
        this.computeStats(data, function(err){
            if(err){ return callback(err) ;}
            return callback(null, data) ;
        });
    }.bind(this));
};

dashboardController.computeStats = function(data, callback){
    var start = data.chosenYear+"-01-01";
    var end = data.chosenYear+"-12-31 23:59:59" ;
    this.api.api.multiread({
        diag: { search : { d_date: {ope: "between", value:[start, end]}}, orderBy: "d_date"}
    }, function(err, reads){
        if(err){ return callback(err) ;}

        var MODES = ["VER", "ALG","TROUBLED", "COLOR", "VER_SPA"] ;
        var countPool = 0;
        var countSpa = 0;
        var countTotal = 0;
        var countModes = {};
        MODES.forEach(function(m){
            countModes[m] = 0;
        }) ;
        var customers = {} ;
        
        var year = moment(start).format("YYYY") ;
        var dataDiagPerMonth = [] ;
        var monthsLabels = [] ;
        var dt = moment(start) ;
        var dtEnd = moment(end) ;
        if(dtEnd.isAfter(moment())){
            dtEnd = moment() ;   
        }
        while(dt.isBefore(dtEnd)){
            monthsLabels.push(moment.localeData(VeloxWebView.i18n.getLang()).months()[dt.month()] + " "+year) ;
            dataDiagPerMonth.push(0) ;
            dt = dt.add(1, "month") ;
        }

        for(var i=0; i<reads.diag.length; i++){
            var diag = reads.diag[i] ;
            if(diag.d_pool_or_spa === "POOL"){
                countPool++;
            }else{
                countSpa++;
            }
            countTotal++;
            var month = moment(diag.d_date).month() ;
            dataDiagPerMonth[month]++ ;
            countModes[diag.d_mode]++ ;
            customers[diag.c_id] = true ;
        }

        var customerCount = Object.keys(customers).length ;
        var countPerCustomer = VeloxWebView.format(customerCount>0?countTotal/customerCount:0, "double");

        
        var diagTypes = [];
        MODES.forEach(function(m){
            diagTypes.push({ name : VeloxWebView.tr("fields.values.diag.d_mode."+m), value : countModes[m]}) ;
        }) ;
            
        var basinTypes = [
            { name : VeloxWebView.tr("customers.pool"), value : countPool},
            { name : VeloxWebView.tr("customers.spa"), value : countSpa}
        ];

        var diagPerMonth = monthsLabels.map(function(monthLabel, i){
            return { name : monthLabel, value: dataDiagPerMonth[i]} ;
        }) ;

        data.basinTypes = basinTypes ;
        data.diagPerMonth = [{ name: "", backgroundColor: "#009BA6", values: diagPerMonth}] ;
        data.diagTypes = diagTypes ;
        data.countPerCustomer = countPerCustomer;

        return callback() ;
    }.bind(this));
} ;


dashboardController.onExportPdf = function(ev){
    this.view.longTask(function(done){
        veloxScriptLoader.load([
            {name: "template-"+VeloxWebView.i18n.getLang(),
                type: "plain",
                version: "1.0.0",
                localPath: "templates/html/dashboardTemplate.html",
            }
        ], function(err, results){
            if(err){ return done(err) ;}
            var html = results[0][0] ;

            var title = VeloxWebView.tr("menu.dashboard")+" "+this.data.chosenYear ;

            html = html.replace("@version@", pkg.humanVersion) ;
            html = html.replace("@title@", title) ;
            html = html.replace("@date@", VeloxWebView.tr("dashboard.editedOn")+' '+moment().format("L")) ;
            html = html.replace("@chart_months@", ev.data.countByMonth) ;
            html = html.replace("@chart_type_ana@", ev.data.diagTypes) ;
            html = html.replace("@chart_type_basin@", ev.data.basinTypes) ;
            html = html.replace("@chart_per_customer@", ev.data.countPerCustomer) ;

            if(window.native){
                //desktop native
                window.native.pdf.genAndOpenReport({html: html, filename: title+".pdf", lang: VeloxWebView.i18n.getLang(), noFooter: true}, done) ;
            }else{
                this.api.pdf.gen(title+".pdf", html, VeloxWebView.i18n.getLang(), true, done) ;
            }
        }.bind(this));
    }.bind(this)) ;
};